import type { ChannelKey, EventKey, LevelRateView } from "@mfa-aff/shared";
import bronze from "@mfa-aff/ui/assets/illustrations/level-bronze.webp";
import contract from "@mfa-aff/ui/assets/illustrations/level-contract.webp";
import diamond from "@mfa-aff/ui/assets/illustrations/level-diamond.webp";
import emerald from "@mfa-aff/ui/assets/illustrations/level-emerald.webp";
import gold from "@mfa-aff/ui/assets/illustrations/level-gold.webp";
import platinum from "@mfa-aff/ui/assets/illustrations/level-platinum.webp";
import silver from "@mfa-aff/ui/assets/illustrations/level-silver.webp";

const BY_RANK = [bronze, silver, gold, emerald, platinum, diamond];

/** Level badge illustration by rank (1 = lowest); ranks past the art reuse the top badge; 0 = an exclusive contract (no level). */
export const levelImage = (rank: number): string => (rank <= 0 ? contract : BY_RANK[Math.min(rank, BY_RANK.length) - 1]!);

/** Rate of one (event, channel) cell, or null when the level has none. */
export const rateOf = (rates: LevelRateView[], event: EventKey, channel: ChannelKey): LevelRateView | null =>
    rates.find((r) => r.event === event && r.channel === channel) ?? null;

/** The four cells the panel shows (link, code pool + d_max, ref code, renewal) as basis points. */
export function rateCard(rates: LevelRateView[]) {
    const code = rateOf(rates, "new", "code");
    return {
        linkBp: rateOf(rates, "new", "link")?.rateBp ?? null,
        codeBp: code?.rateBp ?? null,
        dMaxBp: code?.dMaxBp ?? null,
        refcodeBp: rateOf(rates, "new", "refcode")?.rateBp ?? null,
        renewalBp: (rateOf(rates, "renewal", "link") ?? rates.find((r) => r.event === "renewal"))?.rateBp ?? null,
    };
}
